import api from "./api";

export const searchUsers = (query) =>
  api.get(`/friends.php?search=${encodeURIComponent(query)}`).then((r) => r.data);

export const addFriend = (ami_id) =>
  api.post("/friends.php", { ami_id }).then((r) => r.data);

export const getFriends = () => api.get("/friends.php").then((r) => r.data);

export const removeFriend = (ami_id) =>
  api.delete(`/friends.php?ami_id=${ami_id}`).then((r) => r.data);

export const getFriendStats = (ami_id, annee, mois) =>
  api.get(`/friend_stats.php?ami_id=${ami_id}&annee=${annee}&mois=${mois}`).then((r) => r.data);